import classes from './Button.module.scss';
import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import Link from 'next/link';
import { configureAnchor } from '../../../utils/functions';
import { generateAppsflyerUrl } from '../../../utils/appsflyer';

export default function Button(props) {
    const { url, label, style, isExternal, iconPath, extenderClass } = props;

    const [href, setHref] = useState(url || '');
    const router = useRouter();

    useEffect(() => {
        if (url.includes('i.ayo.ba')) setHref(generateAppsflyerUrl(url));
        else if (url.includes('#')) setHref(configureAnchor(url, router));
        else {
            setHref(`${url}?lang=${router.query?.lang || router.defaultLocale}`);
        }
    }, [router, url]);

    return (
        <Link href={href}>
            <a
                className={`${classes.aBtn} ${classes[`${style}`]} fnt16f ${extenderClass}`}
                rel="noopener"
                target={isExternal}
            >
                {iconPath?.length > 0 && (
                    <figure className={classes.mIcon}>
                        <Image src={iconPath} alt="arrow" width={16} height={16} layout="fixed" />
                    </figure>
                )}
                <span className={classes.aText}>{label}</span>
            </a>
        </Link>
    );
}
